// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.badge[data-v-5b6a06e1] {\r\n  position: absolute;\r\n  top: 12px;\r\n  left: 10px;\r\n  transform: translateY(-50%) translateX(100%);\r\n  background-color: #f56c6c;\r\n  border-radius: 10px;\r\n  color: #fff;\r\n  display: inline-block;\r\n  font-size: 12px;\r\n  height: 18px;\r\n  line-height: 18px;\r\n  padding: 0 6px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border: 1px solid #fff;\n}\r\n", ""]);
// Exports
module.exports = exports;
